module.exports = __webpack_public_path__ + "static/media/HeroCupcake.d721ad14.jpg";